import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { StyledPopupDiv } from '../../atoms/popup/popup.styles';
import { StyledPopupHeaderDiv } from '../../atoms/popupHeader/popupHeader.styles';
import { StyledDateBoxDiv, StyledDatesHeaderDiv } from '../../atoms/DatesHeader/datesHeader.styles';
import { StyledCalendarDiv } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledAddDatesDiv = styled.div`
  ${rtl`
  position: relative;
  height: 100%;
  .DayPicker-Weekday abbr {
    cursor: default;  
  }
  &.advanced-search-calender {
    @media ${theme.mediaQuery.allMobiles} {
      ${StyledPopupDiv} {
        ${StyledCalendarDiv} {
          .DayPicker-Months {
            .DayPicker-Month {
              z-index:10;
              display: flex;
              flex-direction: column;
              .DayPicker-Caption {
                margin-top: 0;
                div {
                  padding-top: ${toRem(30)};
                }
              }
              .DayPicker-Weekdays {
                position: relative;
                margin-top: 0;
                top: 0;
                background: transparent;
                display: flex;
                padding-left: 0 !important;
                padding-right: 0 !important;
              }
              .DayPicker-Body {
                .DayPicker-Week {
                  display: flex;
                  justify-content: space-between;
                }
              }
            }
          }
        }
      }
    }
  }
  @media ${theme.mediaQuery.tablet} {
    height: auto;
    flex: 1;
    margin-right: 30%;
    padding: 0;
  }
  ${StyledCalendarDiv} {
    @media ${theme.mediaQuery.mobileOnly} {
      .DayPicker-Weekdays {
        padding: 0 !important;
        margin-top:${toRem(87)};
      }
    }
  }
  &.search-mobile-dates-wrapper {
    &.shop-page-split-dates-box-wrapper {
      ${StyledPopupHeaderDiv} {
        &.search-dates-popup__header {
          @media ${theme.mediaQuery.mobileOnly} {
            .link-white {
              margin-top: ${toRem(15)};
            }
            div.label-text {
              padding-top: ${toRem(0)} !important;
            }
          }
        }
      }
    }
    ${StyledCalendarDiv} {
      .DayPicker-Months {
        position: fixed;
        height: 100%;
        overflow-y: auto;
        .DayPicker-Month {
          width: 90%;
          .DayPicker-Caption {
            padding-left: 4.5%;
            div {
              font-size: ${toRem(14)};
            }
          }
          .DayPicker-Weekdays {
            left: 0;
            padding-left: 4.9% !important;
            padding-right: 4.9% !important;
          }
        }
      }
    }
  }
  .m-button-s{
    @media ${theme.mediaQuery.desktop}{
      height: ${toRem(40)};
    }
  }
  &.search-dates-wrapper {
    
    @media ${theme.mediaQuery.allTablets} {
      margin-right: 22%;
      padding-left: 1%;
    }
    &.shop-page-split-dates-box-wrapper {
      ${StyledPopupDiv} {
          @media ${theme.mediaQuery.minDesktop} {
            top: -${toRem(16)};
          }
           @media ${theme.mediaQuery.allTablets} {
            top: -${toRem(20)};
            max-height: none;
          }
          @media ${theme.mediaQuery.smallerTablet} {
            left:-85%;
            top: -${toRem(23)};
            width: ${toRem(690)};
          }
          ${StyledDatesHeaderDiv} {
            ${StyledDateBoxDiv} {
              width:${toRem(251)};
              padding-left:${toRem(20)};
               @media ${theme.mediaQuery.allTablets} {
                   padding-left:${toRem(18)};
                }
             &:first-child {
               margin-right: ${toRem(18)};
             }
              button{ 
                span.h-r-form-field-txt  {
                  font-size:${toRem(22)};
                }
                &:first-child {
                  padding-bottom:${toRem(18)};
                  border-color: ${theme.color['dark-gray-14']};
                  &:after {
                    content: "";
                    border-bottom:${toRem(4)} solid transparent;
                    width: ${toRem(232)};
                    position: absolute;
                    right: 0;
                    bottom: 0;
                  }
                  span{
                    opacity: 0.5;
                    letter-spacing: ${toRem(1.3)};
                  }
                }
              }
              &.shop-button-focus {
                opacity:1;
                button {
                  bottom: ${toRem(19)};
                   border-width: ${toRem(1)};
                   border-color: ${theme.color['dark-gray-14']};
                   &:after {
                    border-color: ${theme.color['dark-gray-14']};
                   }
                   span{
                      opacity: 1;
                      letter-spacing: ${toRem(1.3)};
                    }
                }
                @media ${theme.mediaQuery.minDesktop} {
                  &:hover {
                    opacity: 0.6;
                  }
                }
              }
            }
          }
      }
    }
  }
  .h-r-cta-secondary-white {
    background-color: ${theme.color['white']};
  }
  .shop-adf-dates-wrapper {
      left:0% !important;
      z-index:11 !important;
      transform: translateX(${toRem(-18)});
      
      @media ${theme.mediaQuery.mobileOnly} {
      transform: translateX(${toRem(0)});
      }
  }
  
  ${StyledPopupDiv} {
    &.search-page-dates-flexible{
      overflow:hidden;
      @media ${theme.mediaQuery.mobileOnly} {
        display: flex;
        flex-direction: column;
      }
    }
    &.flexible-active {
      @media ${theme.mediaQuery.minDesktop} {
        --gp-placement-max-height: calc(100vh - 50px);
        max-height: var(--gp-placement-max-height);
        overflow-y: auto;
        &.custom-scrollbar::-webkit-scrollbar-track {
          border-radius: ${toRem(14)};
        }
      }
    }
    &.search-page-dates-popup:not(.shop-adf-dates-wrapper){
      @media ${theme.mediaQuery.minDesktop}{
        &:dir(rtl){
        left: ${toRem(18)} !important;
        width: ${toRem(770)};
        }
        &:dir(ltr){
        left: ${toRem(18)} !important;
        width: ${toRem(730)};
        }
      }
    }
    &.search-page-dates-popup {
        z-index:10;
      .DayPicker-Caption {
        >div{
          padding-top: ${toRem(22)};
        }
      }
      .DayPicker-NavButton--next {
        right: ${toRem(11)};
        &:before {
          top:-${toRem(7)};
        }
        @media ${theme.mediaQuery.desktop} {
          right: ${toRem(45)};
          margin-right: ${toRem(-8)};
        }
        @media ${theme.mediaQuery.tablet} {
          margin-right: ${toRem(-16)};
        }
      }
      .DayPicker-NavButton--prev {
        &:before {
          top:-${toRem(7)};
        }
        @media ${theme.mediaQuery.desktop} {
          margin-left: 0 !important;
        }
        @media ${theme.mediaQuery.tablet} {
          margin-left: ${toRem(-24)};
        }
      }
      .DayPicker {
        width: 100%;
        font-family: ${theme.fontFamily.swiss};
        @media ${theme.mediaQuery.desktop} {
          padding-right: ${toRem(18)};
        }
      }
      ${StyledDateBoxDiv} {
        width: 46%;
        margin-right: 3%;
        padding-left: ${toRem(20)};
        &:nth-child(2) {
          margin-right: 0;
          width: 48.5%;
          margin-left: ${toRem(16)};
          @media ${theme.mediaQuery.tablet} {
            margin-left: 0;
          }
        }
      }
      @media ${theme.mediaQuery.minDesktop} {
        ${StyledDateBoxDiv} {
          width: 43.7%;
          margin-right: 4.3%;
          &:nth-child(2) {
            padding-left: ${toRem(33)};
            width: 47.5%;
          }
        }
      }
      @media ${theme.mediaQuery.largeTablet} {
        width: 42pc;
        padding: 1.375rem 0px 2rem;
        left: -13%;
      }
      padding-bottom: ${toRem(27)};
      @media ${theme.mediaQuery.tablet} {
        padding: ${toRem(20)} 0px ${toRem(24)};
      }
      @media ${theme.mediaQuery.desktop} {
        padding: ${toRem(20)} 0px ${toRem(24)};
      }
      .DayPicker-Months {
        .DayPicker-Month {
          height: 100% !important;
          margin: 0 !important;
        }
      }
      ${StyledDatesHeaderDiv} {
        padding: 0px ${toRem(20)} ${toRem(10)} ${toRem(10)};
      }
      @media ${theme.mediaQuery.mobileTablet} {
        width: ${toRem(676)};
        left: -103.4%;
        margin-top: ${toRem(6)};
        ${StyledCalendarDiv} {
          margin-right: ${toRem(14)};
        }
        ${StyledDatesHeaderDiv} {
          padding: 0px ${toRem(20)} ${toRem(10)} ${toRem(17)};
        }
        ${StyledDateBoxDiv} {
          width: 47%;
        }
        .DayPicker-Months {
          display: flex;
          justify-content: space-around;
          padding: 0;
          width: 100%;
          .DayPicker-Month {
            width: 47% !important;
            margin: 0 !important;
          }
        }
      }
      @media ${baseVariables.mediaQuery.md} {
        .DayPicker-Months {
          padding-bottom: ${toRem(18)};
        }
      }
      @media ${baseVariables.mediaQuery.lg} {
        .DayPicker-Months {
          padding: 0px ${toRem(28)} ${toRem(24)} ${toRem(20)};
          justify-content: space-around;
          margin-bottom: ${toRem(14)};
        }
      }
    }
  }
  .search__calendar-label {
    display: block;
    text-transform: uppercase;
    padding-bottom: ${toRem(6)};
    letter-spacing: ${toRem(1.3)};
    ::before {
      color: ${theme.color['light-orange-2']};
      padding-right: ${toRem(8)};
      font-size: ${theme.fonts['fontM']};
    }
    @media ${theme.mediaQuery.desktop} {
      padding-bottom: ${toRem(4)};
    }
  }

  .search__calendar-value {
    white-space: nowrap;
  }

  .h-r-form-field-txt {
    color: ${theme.color['black']};
    font-weight: 700;
  }
  .search__calendar-value-empty {
    color: ${theme.color['dark-gray-4']};
  }

  > button {
    border: 0;
    background-color: transparent;
    text-align: left;
    width: 100%;
    padding: 0;

    @media ${theme.mediaQuery.tablet} {
      padding: ${toRem(21)} ${toRem(24)} ${toRem(25)} ${toRem(23)};
      &:focus {
        outline: revert;
      }
    }
    @media ${theme.mediaQuery.desktop} {
      padding: ${toRem(22)} ${toRem(32)} ${toRem(24)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
      padding: ${toRem(22)} ${toRem(40)} ${toRem(24)};
    }
  }

  .search-dates-popup {
    height: 100%;
    @media ${theme.mediaQuery.tablet} {
      height: auto;
      width: ${toRem(484)};
      left: -${toRem(1)};
      padding: ${toRem(20)} 0 ${toRem(32)};
    }
    @media ${theme.mediaQuery.desktop} {
      width: ${toRem(634)};
      padding: ${toRem(22)} 0 ${toRem(32)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
      width: ${toRem(754)};
      padding: ${toRem(22)} 0 ${toRem(32)};
    }
  }

  .search-dates-popup__header .h-r-form-field-txt {
    font-size: ${toRem(22)};
    line-height: ${toRem(28)};
    letter-spacing: -${toRem(0.5)};
  }

  .toggle-container {
    &__seperator {
  height: ${toRem(3)};
  opacity: 0.18;
}
    @media ${theme.mediaQuery.mobileOnly} {
    z-index: 2;
    background :${theme.color['white-smoke']};
      &__seperator {
        display:none;
      }
    }
  }
  .search-dates-popup__main {
    @media ${theme.mediaQuery.mobileOnly} {
      margin-top:0;
      overflow: hidden;
      height: 100%;
      flex-direction: column;
      > div {
        &:first-child {
          flex: 1;
          height: calc(100% - 60px);

        }
        &:nth-child(2) {
          height: ${toRem(50)};
          padding: ${toRem(16)} ${toRem(24)};
          width: 100%;

        }
      }
    }

    /* START: IE11 fix for styled div as flex:1 not supported */

    @media ${theme.mediaQuery.mobileOnly && theme.mediaQuery.ie11Only} {
      > div {
        &:first-child {
          width: 100%;
        }
      }
    }

    /* END: IE11 fix for styled div as flex:1 not supported */
  }

  `}
`;

export const StyledDatesFooter = styled.div`
  ${rtl`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 ${toRem(30)};
  margin-top:${toRem(-34)};
  padding-top: ${toRem(13)};
  position: relative;
  z-index: 1;
  .reset-btn {
    background:none;
    text-align:left;
    margin-left:0;
    outline:none;
    border: none;
    &:hover {
      border:none;
    }
    &:focus{
      border-bottom:0;
      border-radius: ${toRem(18)};
    }
  }
  .hide-reset-btn {
    visibility:hidden;
  }
  button {
    min-width: ${toRem(108)};
    
    &.reset-btn:focus {
      min-width: fit-content;
      border-radius: ${toRem(8)};
      outline-offset: ${toRem(8)};
      border-bottom: 0;
    }
  }
  .
  .search-page-dates-popup {
    @media ${theme.mediaQuery.desktop} {
      padding: 0 ${toRem(36)} 0 ${toRem(36)};
      z-index:100;
    }
  }
  .search-page-done-button{
    z-index: 99;
  }
  @media ${theme.mediaQuery.desktop} {
    padding: 0 ${toRem(32)} 0 ${toRem(32)};
    bottom: ${toRem(2)};
  }


  }

`}
`;
